/**
* Service Map JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'service-map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.service-map .active-states span' ).each( function() {
        $( '.service-map svg #' + $( this ).attr( 'data-abbr' ) ).addClass( 'is-active' );
        $( '.service-map svg #text-' + $( this ).attr( 'data-abbr' ) ).addClass( 'is-active' );
      } );

      $( '.service-map .active-states .states-group' ).each( function( key, val ) {
        let rtl = true;
        if ( key % 2 === 0 ) {
          rtl = false;
        }
        $( this ).slick( {
          dots: false,
          arrows: false,
          autoplay: true,
          centerMode: true,
          speed: 6000,
          autoplaySpeed: 0,
          rtl: rtl,
          cssEase: 'linear',
          slidesToShow: 4,
          centerPadding: '0',
          infinite: true,
          variableWidth: true,
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-map', COMPONENT );
} )( app );
